<template>
  <div id="app" :class="$style.app">
    <SnackContainer :class="$style.snackContainer" />
    <AppHeader :class="$style.header" />
    <main :class="$style.main">
      <RouterView v-slot="{ Component }" :class="$style.inner" class="d-flex flex-column">
        <transition name="fade" mode="out-in" appear>
          <component :is="Component" />
        </transition>
      </RouterView>
      <footer>
        <footer :class="$style.footer">
          {{ $gettext("Bei Fragen:") }} <strong>{{ $gettext("Telefon") }} 058 122 75 30</strong>
        </footer>
      </footer>
    </main>
  </div>
</template>

<script setup lang="ts">
import "@/styles/main.scss";

import { SnackContainer } from "vue-haystack";

import AppHeader from "@/components/AppHeader.vue";
</script>

<style lang="scss" module>
.app {
  --header-height: #{$app-header-height};
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .snackContainer {
    top: calc(var(--header-height) + #{map.get($spacers, "c-32")});
    right: #{map.get($spacers, "c-32")};
  }

  @include media-breakpoint-up(xl) {
    --header-height: #{$app-header-height-sm};
  }

  .header {
    position: fixed;
    z-index: 1100;
    top: 0;
    right: 0;
    left: 0;
  }

  .main {
    flex-grow: 3;
    display: flex;
    flex-direction: column;

    .inner {
      flex-grow: 1;
    }
  }
}

.footer {
  @extend %label-six;
  text-align: center;
  padding: map.get($spacers, "c-24") 0;
  border-top: solid 1px $grey-five;
}
</style>
